module.exports = __webpack_public_path__ + "media/images/edools-logo-new-44da79fb12e56b4579db69fb627c0fbb.png";